import { Eye, EyeSlash, LockSimple } from '@phosphor-icons/react';
import { TextInput, type TextInputProps } from '@reelplicate/ui';
import { useState } from 'react';

/**
 * Figma password Text Input: lock-simple leading icon and, with `reveal`, the
 * eye in the Trailing icon slot as a real show/hide toggle.
 */
export function PasswordInput({
  reveal = false,
  ...props
}: Omit<TextInputProps, 'type' | 'leadingIcon'> & { reveal?: boolean }) {
  const [shown, setShown] = useState(false);
  const Icon = shown ? EyeSlash : Eye;
  return (
    <TextInput
      {...props}
      type={shown ? 'text' : 'password'}
      leadingIcon={LockSimple}
      trailingAction={
        reveal && (
          <button
            type="button"
            aria-label={shown ? 'Hide password' : 'Show password'}
            aria-pressed={shown}
            onClick={() => setShown((s) => !s)}
            className="text-icon-secondary focus-visible:shadow-focus-ring flex shrink-0 cursor-pointer rounded-xs outline-none"
          >
            <Icon aria-hidden className="size-[18px]" />
          </button>
        )
      }
    />
  );
}
